import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../helpers';

export const GRAFICAS_INICIO_SINIESTROS = `
    query graficas($filtro: InputInicioSiniestros){
        getInicioSiniestrosGraficas(filtro: $filtro){
            grafica
            etiqueta
            total
            monto
        }
    }`;

// Conteos y montos (en pesos) de reportes de daños y reclamos para las gráficas de Inicio Siniestros
export const getInicioSiniestrosGraficas = async (filtro, token) => {
    try {
        let { getInicioSiniestrosGraficas } = await FetchAPI.graphql({
            token,
            variables: { filtro },
            url: urlServidor,
            query: GRAFICAS_INICIO_SINIESTROS
        });

        return getInicioSiniestrosGraficas;

    } catch ({ message }) { throw new Error(message); }
}
